<div class="modal-header">
  <h5 class="claim-modal-title">{{ stFormName }}</h5>
  <button type="button" (click)="cancelFunction()" class="close close-icon" data-testid="addnew-claims-close-button">
    <img src="../../../../../assets/images/close.svg">
  </button>
</div>
<form class="claims-form" [formGroup]="formSubmission" (keydown.enter)="$event.preventDefault()">
  <mat-dialog-content>
    <div *ngIf="!isClaimEdit" class="table-box feedback-table section pdgb20">
      <div class="selector-wrap">
        <div *ngIf="isBatch == false" class="report-box">
          <span class="report-type-mrg">Report type</span>
          <div class="selector" *ngIf="!isBatch">
            <div class="selecotr-item">
              <input type="radio" id="radio4" name="selector" value="4" [checked]="reportTypeId === 4"
                (change)="changeReportType($event)" [disabled]="!isIdentityReport" class="selector-item_radio" data-testid="addnew-claims-identity-input">
              <label for="radio4" class="selector-item_label">Identity</label>
            </div>
            <div class="selecotr-item">
              <input type="radio" id="radio1" name="selector" value="1" [checked]="reportTypeId === 1"
                [disabled]="disableReportType()" (change)="changeReportType($event)" [disabled]="!isBasicReport" class="selector-item_radio"
                data-testid="addnew-claims-basic-input">
              <label for="radio1" class="selector-item_label">Basic</label>
            </div>
            <div class="selecotr-item">
              <input type="radio" id="radio2" name="selector" value="2" [checked]="reportTypeId === 2"
                (change)="changeReportType($event)" [disabled]="!isEnhancedReport" class="selector-item_radio" data-testid="addnew-claims-enhanced-input">
              <label for="radio2" class="selector-item_label">Enhanced</label>
            </div>
            <div class="selecotr-item">
              <input type="radio" id="radio3" name="selector" value="3" [checked]="reportTypeId === 3"
                (change)="changeReportType($event)" [disabled]="!isMonitoringReport" class="selector-item_radio" data-testid="addnew-claims-monitoring-input">
              <label for="radio3" class="selector-item_label">Monitoring</label>
            </div>
          
          </div>
        </div>
      </div>
    </div>

    <div class="title-box" *ngIf="currentUserRole == 'super admin'">
      <h6>Reviewer</h6>
    </div>
    <div [ngClass]="'add-form'" [hidden]="currentUserRole != 'super admin'">
      <div class="row formheight fields-mrg">
        <div class="col-md-12 col-12">
          <div class="row">
            <div class="col-md-4 col-12">
              <label>Client</label>
              <select data-testid="addnew-claims-client-select" formControlName="stClient"
                class="border-input select select-reviewer val-css"
                [ngClass]="{ 'is-invalid': (submitted || isBatchsubmitted || !isFileExist) && Individualgetter['stClient'].errors }"
                (change)="onChangeClient($event)">
                <option value="" disabled selected class="mrgl45">Select client</option>
                <option value="{{clientsDetails.uiClientId}}" *ngFor="let clientsDetails of clientsData">
                  {{clientsDetails.stClient}}</option>
              </select>
            </div>

            <div class="col-md-4 col-12">
              <label>Examiner</label>
              <select data-testid="addnew-claims-examiner-select" formControlName="stExaminer"
                class="border-input select select-reviewer val-css"
                [ngClass]="{ 'is-invalid': (submitted || isBatchsubmitted) && Individualgetter['stExaminer'].errors }"
                (change)="onChangeExaminer($event)">
                <option value="" disabled selected class="mrgl45">Select examiner</option>
                <option value="{{userlist.userId}}" *ngFor="let userlist of userData">{{userlist.stName}}</option>
              </select>
            </div>

            <div class="col-md-4 col-12">
              <label>Team</label>
              <select data-testid="addnew-claims-examiner-select" formControlName="stUserTeam"
                class="border-input select select-reviewer val-css"
                [ngClass]="{ 'is-invalid': (submitted || isBatchsubmitted) && Individualgetter['stUserTeam'].errors && userteams?.length > 0 }"
                (change)="onChangeTeam($event)">
                <option value="" disabled selected class="mrgl45">Select team</option>
                <option value="{{t.uiTeamId}}" *ngFor="let t of userteams">{{t.stName}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isClaimEdit" class="mt-5"></div>
    <div class="title-box" [ngClass]="currentUserRole == 'super admin' ? 'mt-30' : ''">
      <h6 *ngIf="isBatch == false">Required fields </h6>
      <!-- <div [hidden]="currentUserRole == 'super admin' || isClaimEdit" class="checkout-wrap"
        style="margin-top: 5px !important;">
        <label class="batchfont">Batch submission</label>
        <div class="checkout">
          <input class="form-check-input" type="checkbox" [attr.checked]="isBatch ? true : null " (change)="IsSubmissionChange($event)"
            data-testid="addnew-claims-batch-input">
          <div class="checkout-box"></div>
        </div>
      </div> -->
    </div>
    <div [ngClass]="'add-form'" [hidden]="isBatch == true">
      <div class="row formheight fields-mrg">
        <div class="col-md-12 col-12">
          <div class="row">
            <div class="col-md-4 col-12 input-login">
              <input _ngcontent-iam-c175="" autocomplete="off" type="text" required="" formControlName="stFirstName"
                id="txtFirstName" class="border-input ng-pristine ng-invalid ng-touched ng-submitted val-css"
                ng-reflect-required="" ng-reflect-name="client" ng-reflect-model="" maxlength="50"
                ng-reflect-ng-class="[object Object]" (blur)="firstnameValidate()"
                data-testid="addnew-claims-firstname-input"
                [ngClass]="{ 'is-invalid': (firstNameInvalid) || submitted && Individualgetter['stFirstName'].errors }">
              <label _ngcontent-iam-c175="">First name</label>
            </div>
            <div class="col-md-4 col-12 input-login">          
              <input _ngcontent-iam-c175="" autocomplete="off" type="text" required="" formControlName="stLastName"
                id="txtLastName" class="border-input ng-pristine ng-invalid ng-touched val-css ng-submitted"
                ng-reflect-required="" ng-reflect-name="client" ng-reflect-model="" maxlength="50"
                ng-reflect-ng-class="[object Object]" (blur)="lastnameValidate()"
                data-testid="addnew-claims-lastname-input"
                [ngClass]="{ 'is-invalid': (lastNameInvalid) || submitted && Individualgetter['stLastName'].errors }">
              <label _ngcontent-iam-c175="">Last name</label>
            </div>
            <div class="col-sm-4 col-12 input-login">
              <input type="text" autocomplete="off" required
                class="border-input dobFocus ng-submitted ng-pristine ng-invalid ng-touched val-css" #dateofbirth
                formControlName="dtDateofBirth" id="txtdtDateofBirth" data-testid="addnew-claims-dateofbirth-input"
                (blur)="dateValidate(dateofbirth.value,'dtDateofBirth');"
                [ngClass]="{ 'is-invalid': (dateOfBirthInvalid) || (submitted && Individualgetter['dtDateofBirth'].errors) || (individualAgeInvalid) }"
                (keypress)="dateAllowNumericSlash($event); whiteSpace($event);"
                [ngStyle]="{'cursor': isClaimEdit ? 'default' : ''}"
                onKeyPress="if(this.value.length==10) return false;" ondrop="return false;" />
              <i class="fa fa-calendar calendar-icon" #dpdate (click)="showCalendar('dtDateofBirth')"
                [ngStyle]="{'pointer-events': isClaimEdit ? 'none' : 'auto'}"
                (bsValueChange)="dateChange($event,'dtDateofBirth')" bsDatepicker [maxDate]="today" id="dpDateofBirth"
                [bsConfig]="datePickerConfig" [(bsValue)]="bsValueDateOfBirth"></i>
              <label>Date of birth</label>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 col-12 input-login">
              <input _ngcontent-iam-c175="" autocomplete="off" type="text" required="" formControlName="stAddress"
              id="txtAddress" class="border-input ng-pristine ng-invalid ng-touched ng-submitted val-css"
              ng-reflect-required="" ng-reflect-name="client" ng-reflect-model="" maxlength="150"
              ng-reflect-ng-class="[object Object]" (change)="addressValidate()" (focus)="addressOnFocus()"
              (blur)="onAddressOrAdditionalAddressBlur()"
              data-testid="addnew-claims-address-input"
              (keydown)="onAddressInputKeydown($event)"
              [ngClass]="{ 'is-invalid': (isValidZip || addressInvalid) || submitted && Individualgetter['stAddress'].errors }">
              <label _ngcontent-iam-c175="">Address
                <i class="fa fa-info-circle injury-date popover-icon" placement="top"
             [ngbPopover]="addressContent" [popoverClass]="isInputFocused ? 'volumePopover addresswidthPopover focused' : 'volumePopover addresswidthPopover'" triggers="mouseenter:mouseleave"></i>
              </label>
              <ng-template #addressContent>
               
                <div>
                  Enter full address with zipcode <br>(e.g. zipcode format 12345 or K1A 0B1)
                </div>
            </ng-template>
            <ul *ngIf="addressSuggestions.length && showSuggestions" class="list-group suggestion-box">
              <li *ngFor="let suggestion of addressSuggestions; let i = index" class="list-group-item list-group-item-action"
                [class.active]="i === highlightedAddressSuggestionIndex"
                (mousedown)="selectSuggestion(suggestion); addressValidate(); $event.preventDefault()"
                [attr.tabindex]="0">
                {{ suggestion }}
              </li>
            </ul>
            </div>
            <!-- <div class="col-md-4 col-12 input-login">
              <input _ngcontent-iam-c175="" type="text" autocomplete="off" required="" formControlName="stZipcode"
                class="border-input ng-pristine ng-invalid ng-touched zipcodeFocus val-css ng-submitted"
                ng-reflect-required="" ng-reflect-name="client" ng-reflect-model=""
                ng-reflect-ng-class="[object Object]" [ngStyle]="{'cursor': isClaimEdit ? 'default' : ''}"
                [ngClass]="{ 'is-invalid': (isValidZip) || (submitted && Individualgetter['stZipcode'].errors) }"
                maxlength="7" (keyup)="zipLengthValidation()" (copy)="$event.preventDefault()"
                data-testid="addnew-claims-zipcode-input" (blur)="zipValidation()"
                ondrop="return false;">
              <label _ngcontent-iam-c175="">Zip code</label>
            </div> -->
            <div class="col-sm-4 col-12 input-login">
              <input type="text" autocomplete="off" required
                class="border-input input-custom-margin claimdateFocus ng-submitted ng-pristine ng-invalid ng-touched val-css" #claimfile
                formControlName="dtClaimFile" id="txtClaimFileDate" data-testid="addnew-claims-claim-date-input" (focus)="isInputFocused = true"
                (blur)="isInputFocused = false; dateValidate(claimfile.value,'dtClaimFile');"
                [ngClass]="{ 'is-invalid': (claimFileDateInvalid) || (submitted && Individualgetter['dtClaimFile'].errors) }"
                (keypress)="dateAllowNumericSlash($event); whiteSpace($event);"
                [ngStyle]="{'cursor': isClaimEdit ? 'default' : ''}"
                onKeyPress="if(this.value.length==10) return false;" ondrop="return false;" />
                <fa-icon *ngIf="isLookBackWarningMessageVisible" class="warning-icon" [icon]="faWarning"></fa-icon>
              <i class="fa fa-calendar calendar-icon" (click)="showCalendar('dtClaimFile')"
                [ngStyle]="{'pointer-events': isClaimEdit ? 'none' : 'auto'}"
                (bsValueChange)="dateChange($event,'dtClaimFile')" bsDatepicker [maxDate]="today" id="dpClaimDate"
                [bsConfig]="datePickerConfig" [(bsValue)]="bsValueClaimDate"></i>
              <label>Look-back date <!--Claim date-->
                <i class="fa fa-info-circle injury-date popover-icon" placement="top"
                [ngbPopover]="injuryDateContent" [popoverClass]="isInputFocused ? 'volumePopover widthPopover focused' : 'volumePopover widthPopover'" triggers="mouseenter:mouseleave"></i>
              </label>
              <ng-template #injuryDateContent>
               
                <div>
                  Extra charge applies beyond 24 months
                </div>
            </ng-template>
            
            <span *ngIf="isLookBackWarningMessageVisible" class="error-custom-message">
              Extra charge applies beyond 24 months
            </span>
            </div>
            <div class="col-md-4 col-12 input-login" [class.reference-linkout-locked]="isLinkoutReferenceReadOnly">
              <input _ngcontent-iam-c175="" type="text" autocomplete="off" required="" formControlName="stReferenceId"
                (keypress)='whiteSpace($event)' (blur)="referenceIdValidate()" maxlength="30"
                class="border-input ng-pristine ng-invalid ng-touched val-css" ng-reflect-required="" ng-reflect-name="client"
                ng-reflect-model="" ng-reflect-ng-class="[object Object]" data-testid="addnew-claims-reference-input"
                [ngClass]="{
                  'has-value': isLinkoutReferenceReadOnly,
                  'is-invalid': !isLinkoutReferenceReadOnly && ((referenceIdInvalidate) || (submitted && Individualgetter['stReferenceId'].errors))
                }">
              <label _ngcontent-iam-c175=""> Reference # </label>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="title-box mt-30" *ngIf="isBatch == false">
      <h6>Optional fields</h6>
    </div>
    <div [ngClass]="'add-form'" [hidden]="isBatch == true">
      <div class="row formheight fields-mrg">
        <div class="col-md-8 col-8">
          <div class="row">
            <div class="col-md-6 col-12 input-login">
              <input type="text" autocomplete="off" required class="border-input position-relative focus phoneFocus"
                formControlName="stPhoneNumber" ondrop="return false;" data-testid="addnew-claims-phone-number-input"
                [ngClass]="{ 'is-invalid': submitted && Individualgetter['stPhoneNumber'].errors, 'ellipsis-input': showMorePhoneText}" />
              <span class="plus-icon-claim">
                <fa-icon class="cursor-icon" [icon]="faPlus"
                  (click)="showMultiplePhoneModel(multiplePhone, 'individual')"></fa-icon>
              </span>
              <label _ngcontent-iam-c175="">Phone number</label>
            </div>

            <div class="col-md-6 col-12 input-login">
              <input _ngcontent-iam-c175="" autocomplete="off" type="text" required="" formControlName="stEmail"
                id="txtEmail" autocomplete="off" ondrop="return false;" data-testid="addnew-claims-email-input"
                class="border-input ng-pristine ng-invalid ng-touched position-relative focus emailFocus"
                (keypress)='whiteSpace($event);' style="position: relative;"
                [ngClass]="{ 'is-invalid': submitted || Individualgetter['stEmail'].errors && (Individualgetter['stEmail'].dirty || Individualgetter['stEmail'].touched)}">
              <span class="plus-icon-claim">
                <fa-icon class="cursor-icon" [icon]="faPlus"
                  (click)="showMultipleEmailModel(multipleEmail, 'individual')"></fa-icon>
              </span>
              <label _ngcontent-iam-c175="">Email</label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-12 input-login">
              <input _ngcontent-iam-c175="" type="text" autocomplete="off" required="" formControlName="stCompanyName"
                class="border-input ng-pristine ng-invalid ng-touched" ng-reflect-required="" ng-reflect-name="client"
                ng-reflect-model="" ng-reflect-ng-class="[object Object]" data-testid="addnew-claims-company-name-input"
                [ngClass]="{ 'is-invalid': submitted && Individualgetter['stCompanyName'].errors }" #CompanyName
                maxlength="40" (keypress)="checkCharLength(CompanyName.value,$event)">
              <label _ngcontent-iam-c175="">Company name</label>
            </div>
            <div class="col-md-6 col-12 input-login">
              <input _ngcontent-iam-c175="" type="text" autocomplete="off" required="" formControlName="stOccupation"
                id="txtCompanyName" class="border-input ng-pristine ng-invalid ng-touched" ng-reflect-required=""
                ng-reflect-name="client" ng-reflect-model="" ng-reflect-ng-class="[object Object]"
                data-testid="addnew-claims-occupation-input"
                [ngClass]="{ 'is-invalid': submitted && Individualgetter['stOccupation'].errors }" maxlength="40"
                #Occupation (keypress)="checkCharLength(Occupation.value,$event)">
              <label _ngcontent-iam-c175=""> Occupation </label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-6 input-login">
              <label class="gender-label"></label>
              <select class="border-input ng-pristine ng-invalid ng-touched select gender-dropdown val-css"
                formControlName="stGender"
                data-testid="addnew-claims-gender-select">
                <option value="" disabled selected class="gender-options">Gender</option>
                <option *ngFor="let option of genderOptions" class="gender-options" [value]="option.value">{{
                  option.label }}</option>
              </select>
            </div>
            <div class="col-md-6 col-12 input-login">
              <input type="text" autocomplete="off" required class="border-input position-relative focus additionalAddressFocus"
                formControlName="stAdditionalAddress" ondrop="return false;" data-testid="addnew-claims-additional-address-input"
                [ngClass]="{'ellipsis-input': showMoreAddressText}" [class.has-value]="getAdditionalAddressCount() > 0 || formSubmission.get('stAdditionalAddress')?.value" readonly />
              <span class="plus-icon-claim">
                <fa-icon class="cursor-icon" [icon]="faPlus"
                  (click)="showMultipleAddressModel(multipleAddress, 'individual')"></fa-icon>
              </span>
              <label _ngcontent-iam-c175="">Additional address</label>
            </div>
            
            <div class="col-md-6 col-6 input-login">
              <input type="text" autocomplete="off" required class="border-input position-relative focus knownasFocus"
                formControlName="stKnownAs" ondrop="return false;" data-testid="addnew-claims-known-as-input"
                [ngClass]="{'ellipsis-input': showMoreKnownAsText}" />
              <span class="plus-icon-claim">
                <fa-icon class="cursor-icon" [icon]="faPlus"
                  (click)="showMultipleKnownAsModal(multipleKnownAs, 'newClaim')"></fa-icon>
              </span>
              <label _ngcontent-iam-c175="">Known as</label>
            </div>
            <div class="col-md-6 col-6 input-login">
              <input type="text" autocomplete="off" required class="border-input position-relative focus keywordFocus"
                formControlName="stKeywords" ondrop="return false;" data-testid="addnew-claims-keywords-input"
                [ngClass]="{'ellipsis-input': showMoreKeywordText}" />
              <span class="plus-icon-claim">
                <fa-icon class="cursor-icon" [icon]="faPlus"
                  (click)="showMultipleKeywordModal(multipleKeyword, 'newClaim')"></fa-icon>
              </span>
              <label _ngcontent-iam-c175="">Keywords</label>
            </div>
            <div class="col-md-6 col-6 input-login">
              <input _ngcontent-iam-c175="" type="text" autocomplete="off" required="" formControlName="stNotes"
                class="border-input ng-pristine ng-invalid ng-touched" ng-reflect-required="" ng-reflect-name="client"
                ng-reflect-model="" ng-reflect-ng-class="[object Object]" data-testid="addnew-claims-notes-input">
              <label _ngcontent-iam-c175=""> Notes </label>
            </div>

            <!-- <div class="col-md-6 col-12 input-login">
              <input _ngcontent-iam-c175="" type="text" autocomplete="off" required="" formControlName="stReferenceId"
                (keypress)='whiteSpace($event)' (blur)="referenceIdValidate()" maxlength="30"
                class="border-input ng-pristine ng-invalid ng-touched val-css" ng-reflect-required="" ng-reflect-name="client"
                ng-reflect-model="" ng-reflect-ng-class="[object Object]" data-testid="addnew-claims-reference-input"
                [ngClass]="{ 'is-invalid': (referenceIdInvalidate) || (submitted && Individualgetter['stReferenceId'].hasError('pattern')) }">
              <label _ngcontent-iam-c175=""> Reference # </label>
            </div> -->
          </div>
        </div>
        <div class="col-md-4 col-4 dropdownset">
          <div class="row physical">
            <div class="col-md-6 col-6 pl-25">
              <label _ngcontent-iam-c175="" class="physical-label">Limitation</label>
              <i class="fa fa-info-circle popover-icon" style="cursor: pointer; margin-left: 4px;" placement="right"
                [ngbPopover]="physicalContent" popoverClass="volumePopover" triggers="mouseenter:mouseleave"></i>
              <ng-template #physicalContent>
                <div style="padding-left: 0px;">
                  <p style="color: black;" class="request-info-list" *ngFor="let objpl of arrPhysicalLimitatioin">
                    <b>{{objpl.name}} - </b> {{objpl.description}}
                  </p>
                </div>
              </ng-template>

              <div class="checkbox-wrap color-checkbox-wrap mrg-checkbox"
                *ngFor="let objpl of arrPhysicalLimitatioin; let indexOfelement=index;">
                <div class="form-check">
                  <input type="checkbox" class="td-chk ng-valid ng-dirty ng-touched" ng-reflect-model="true"
                    (change)="changePhysicalLimitation($event, objpl.id, objpl.name,indexOfelement)"
                    id="{{indexOfelement}}_{{objpl.name}}"
                    [attr.data-testid]="'addnew-claims-limitation-input-'+ indexOfelement">
                  <label>
                    {{objpl.name}}
                  </label>
                </div> &nbsp;
              </div>
            </div>
            <div class="col-md-6 col-6 upload-file">
              <label _ngcontent-iam-c175="">Face image
                <i class="fa fa-info-circle popover-icon"
                  style="cursor: pointer; margin-left: 4px;" placement="top right" type="button"
                  popoverClass="volumePopover set-pos-tooletip" triggers="mouseenter:mouseleave" ngbPopover="Upload face image"></i></label>

              <div class="box">
                <div class="col-md-4 col-sm-12 col-12" style="padding-right: 0px;">
                  <input type="hidden" id="faceImageHidden" data-testid="addnew-claims-face-image-input">
                </div>
                <div class="upload-main-wrapper-face-image">
                  <div class="upload-wrapper upload-face-image" id="upload-face-image-wrapper"
                    *ngIf="faceImageUrl == null || faceImageUrl == ''">
                    <input type="file" id="upload-face-image" #inputFile (change)="addFaceImageFile($event)" required
                      placeholder="Upload file" data-testid="addnew-claims-drag-drop-input" accept="image/*">
                    <span id="face-image-file-uploading-start" class="file-upload-text" style="margin-bottom: 0;padding: 0;text-align: center;">Drag
                      and drop or
                      <u id="face-image-file-browse">browse</u></span>
                    <br>
                    <i class="fa fa-cloud-upload" style="padding-left: 0 !important; position: relative;left: 50%;transform: translateX(-50%);" aria-hidden="true"></i>
                    <div class="file-success-text">
                      <span id="face-image-file-upload-name" style="padding-top: 20px; margin-right: 10px;"></span>
                    </div>
                  </div>
                  <div *ngIf="faceImageUrl != null && faceImageUrl != ''" class="face-container">
                    <img [src]="faceImageUrl" class="upload-face-image">
                    <i class="fa fa-trash face-icon face-delete-icon" (click)="removeFaceImage()"></i>
                  </div>
                </div>
              </div>
              <!-- 
              <div *ngIf="!item.get('stImageUrl')?.value" class="upload-main-wrapper"></div> -->
            </div>
          </div>
          <div class="row mt-12">
            
          </div>

          <div class="row">
            <div class="col-md-12 col-12 input-login"
              [ngClass]="{'disabled-click' : isClaimEdit && claimInfo?.inReportTypeId == 'Basic'}">
              <input type="text" autocomplete="off" required
                class="border-input position-relative focus linkAnalysisFocus" formControlName="stLinkAnalysis"
                ondrop="return false;" data-testid="addnew-claims-linkAnalysis-input"
                [ngClass]="{'ellipsis-input': showMoreLinkAnalysisText}" />
              <span class="plus-icon-claim"
                [ngClass]="{'disabled-click' : isClaimEdit && claimInfo?.inReportTypeId == 'Basic'}">
                <fa-icon class="cursor-icon" [icon]="faPlus"
                  (click)="showMultipleLinkAnalysisModal(multipleLinkAnalysis, 'newClaim')"></fa-icon>
              </span>
              <label _ngcontent-iam-c175="">Link analysis</label>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12 col-12">
              
              <div class="d-flex input-login ">
                  <div class="licenseplate">
                    <input maxlength="50" type="text" autocomplete="off" required="" formControlName="stLicensePlate"
                    class="border-input ng-pristine alignment-input" data-testid="addnew-claims-licenseplate-input">
                    <label style="left: 0;"> License plate </label>
                  </div>

                  <mat-select panelClass="select-open-up select-state-box" class="custom-select border-input alignment-input"
                    formControlName="stState">
                    <mat-option class="default-option" selected value="">Select state</mat-option>
                    <mat-option *ngFor="let state of stateOptions" [value]="state.label">
                      {{ state.label }}
                    </mat-option>
                  </mat-select>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
    <!-- Individual submission end -->

    <!-- Batch Submission start -->
    <div [ngClass]="'add-form'" [hidden]="isBatch == false">
      <div class="row formheight fields-mrg">
        <div class="col-md-12 col-12">
          <div class="row">
            <div class="col-md-3 col-sm-12 col-12 input-login">
              <h6  class="label-row">1|&nbsp;<span class="stepInfo">Name {{batchLabelName}}</span></h6>
              <!-- <h6 *ngIf="batchLabelName === 'XML' || batchLabelName === 'Doc'" class="label-row">1|&nbsp;<span class="stepInfo">Name {{batchLabelName}}</span></h6> -->
              <!-- <h6 *ngIf="batchLabelName === 'Batch'" class="label-row">1|&nbsp;<span class="stepInfo">Name batch</span></h6> -->
              <input _ngcontent-iam-c175="" type="text" required=""
                class="border-input batchname ng-pristine ng-invalid ng-touched val-css" ng-reflect-required=""
                ng-reflect-name="client" ng-reflect-model="" formControlName='stBatchName'
                data-testid="addnew-claims-batch-name-input" ng-reflect-ng-class="[object Object]"
                onKeyPress="if(this.value.length==50) return false;"
                (blur)="trimLeadingAndTrailingSpaces(Individualgetter['stBatchName'])"
                [ngClass]="{ 'is-invalid': isBatchsubmitted && Individualgetter['stBatchName'].errors }">
              <div *ngIf="isBatchsubmitted &&  Individualgetter['stBatchName'].errors" class="invalid-feedback">
                <div *ngIf="Individualgetter['stBatchName'].errors['required']" class="invalid-margintop">
                </div>
              </div>
              <label _ngcontent-iam-c175="" class="batchnamelable">{{batchLabelName}} name</label>
            </div>
            <div class="col-md-1 col-sm-12 col-12 ">
            </div>
            <div class="col-md-4 col-sm-12 col-12 upload-file">
              <h6 *ngIf="batchLabelName === 'XLS' || batchLabelName === 'XML' || batchLabelName === 'DOC'" class="label-row">2|&nbsp;<span class="stepInfo">Upload {{batchLabelName}}</span></h6>
              <h6 *ngIf="batchLabelName === 'Batch'" class="label-row">2|&nbsp;<span class="stepInfo">Upload batch</span></h6>
              <div class="box">
                <div class="col-md-4 col-sm-12 col-12" style="padding-right: 0px;">
                  <input type="hidden" id="productMissingHidden" data-testid="addnew-claims-upload-batch-input">
                </div>
                <div class="upload-main-wrapper">
                  <div class="upload-wrapper" id="upload-wrapper">
                    <input type="file" id="upload-file" #inputFile (change)="addfile($event)" required
                      placeholder="Upload file" data-testid="addnew-claims-drag-drop-input"
                      [accept]="fileType" (click)="validateFile($event); inputFile.value = ''">
                    <span id="file-uploading-start" class="file-upload-text" style="font-size: 11.95px !important;">Drag
                      and drop or
                      <u id="file-browse">browse</u></span>
                    <br>
                    <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                    <div class="file-success-text">
                      <span>Successfully uploaded</span>
                    </div>
                    <div class="file-success-text">
                      <span id="file-upload-name" style="padding-top: 20px; margin-right: 10px;"></span>
                    </div>
                  </div>
                </div>
                <div class="census-sub-label batch">
                  <span>Template&nbsp;</span>
                  <i class="fa fa-info-circle popover-icon" (click)="downloadSample()" style="cursor: pointer;"
                    data-testid="addnew-claims-template" placement="right" ngbTooltip="Download sample file"
                    tooltipClass="ngTooltip"></i>
                </div>

              </div>
            </div>
            <div class="col-md-4 col-sm-12 col-12">
              <h6 class="label-row">3|&nbsp;<span class="stepInfo">Review & submit</span></h6>
              <div class="box text-center btn-box bottom-btn"
                [ngClass]="{ removemargingclientbox: isUploadedBatchFile }">
                <div *ngIf="validUploadedData > 0" class="review-icon">
                  <i class="fa fa-warning" (click)="showModalReviewPopup(content)"
                    data-testid="addnew-claims-review-popup"
                    style="line-height: 1em; font-size: 50px;color: yellow;cursor: pointer; margin-left:80px !important"></i>
                  <br>
                  <span class="cecnsusuploaded"
                    style="font-size: 13px !important;color: #FF4343 !important; margin-left:10px !important">{{validUploadedData}}
                    of
                    {{ totalUploadedData }} requests missing data</span>
                </div>

                <div *ngIf="validUploadedData == 0 && totalUploadedData > 0" class="review-icon">
                  <svg version="1.1" id="check" xmlns="http://www.w3.org/2000/svg"
                    (click)="showModalReviewPopup(content)" data-testid="addnew-claims-check"
                    style="width: 48px; height: auto; margin-bottom: 10px; cursor: pointer; margin-left:80px !important"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100"
                    xml:space="preserve">
                    <circle style="fill:rgba(0,0,0,0);stroke-width:10;stroke-miterlimit:10;" cx="49.799" cy="49.746"
                      r="44.757" />
                    <polyline
                      style="fill:rgba(0,0,0,0);stroke:#397c29;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                      points="
                                                    27.114,51 41.402,65.288 72.485,34.205 " />
                  </svg>

                  <br>
                </div>
                <a style="cursor: pointer;" (click)="showModalReviewPopup(content)" class="d-none"
                  id="batch-upload-data-info" data-testid="addnew-claims-review-complete-button">
                  <span class="cecnsusuploaded"><u>Review and complete</u></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- Batch submission end -->

  </mat-dialog-content>

  <mat-dialog-actions style="background-color:#313145;margin-bottom: 0px">
    <div class="section d-flex justify-content-center">
      <button type="button" (click)="cancelFunction()" class="btn-wrap red-btn CancelBox" style="margin-right: 15px;"
        data-testid="addnew-claims-cancel-button">
        Cancel
      </button>
      <button type="button" class="btn-wrap btn-box" (click)="onSubmit($event)" (keydown.enter)="$event.preventDefault()"
        [disabled]="isButtonDisabled" data-testid="addnew-claims-submit-button">
        Submit
      </button>
    </div>
  </mat-dialog-actions>
</form>

<!-- Modal - Multiple Phone number -->
<ng-template #multiplePhone let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Phone number</h5>
    <button type="button" class="close close-icon" aria-label="Close"
      (click)="modal.dismiss('Cross click'); closeMultiplePhoneModel()"
      data-testid="addnew-claims-phone-number-close-button">
      <span aria-hidden="true"><img src="../../../../../assets/images/close.svg" /></span>
    </button>
  </div>
  <div class="modal-body modal-background">
    <div class="popup-form">
      <form [formGroup]="multiplePhoneForm">
        <div>
          <div class="box-wrap not-selectable">
            <div class="row">
              <div class="col-sm-12 col-12 input-login">
                <input type="text" autocomplete="off" class="border-input position-relative modal-color val-css" #phone
                  required="" data-testid="addnew-claims-multiple-phone-input" formControlName="phone"
                  mask="(000) 000-0000" (keyup)="checkDuplicatePhone($event, phone.value); RestrctionOnError($event)"
                  (keydown.enter)="addPhoneOnEnter()"
                  [ngClass]="{ 'is-invalid': multiPhoneFormSubmit && (multiPhoneControlGetter['phone'].errors || showPhoneMessage || !isAllowedMultiplePhoneNumber) || this.multiplePhoneForm.get('phone')?.hasError('invalid') }" />
                <span class="plus-icon-claim icon-cursor" (click)="addMultiplePhone(true,false)">
                  <svg width="15" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 12.4667H12.4667V22H9.53333V12.4667H0V9.53333H9.53333V0H12.4667V9.53333H22V12.4667Z"
                      fill="#6452C5" />
                  </svg>
                </span>
                <label class="label">Phone number</label>
                <div class="max-phone-invalid" *ngIf="!isAllowedMultiplePhoneNumber">Max two phone numbers allowed to add</div>

                <div class="alignment-list" *ngFor="let phoneNumber of multiplePhoneData; index as i">
                  <div class="chip">
                    <div class="chip-content phone-chip modal-color">{{phoneNumber}}</div>
                    <div class="chip-close icon-cursor" (click)="removePhoneNumber(i)"
                      [attr.data-testid]="'phone-input-'+i">
                      <svg width="15" height="20" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1"
                        viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path
                          d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"
                          fill="#d94d51" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-box pdgtb">
          <button type="button" class="btn-wrap red-btn CancelBox modal-color"
            (click)="modal.dismiss('Cross click'); closeMultiplePhoneModel()"
            data-testid="addnew-claims-multiple-phone-cancel-button">
            Cancel
          </button>&nbsp;
          <button type="submit" class="btn-wrap CancelBox modal-color" (click)="savePhoneNumber()"
            data-testid="addnew-claims-multiple-phone-save-button">
            Save
          </button>&nbsp;
        </div>
      </form>
    </div>
  </div>
</ng-template>

<!-- Modal - Multiple Email -->
<ng-template #multipleEmail let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Email</h5>
    <button type="button" class="close close-icon" aria-label="Close"
      data-testid="addnew-claims-multiple-email-close-button"
      (click)="modal.dismiss('Cross click'); closeMultipleEmailModel()">
      <span aria-hidden="true"><img src="../../../../../assets/images/close.svg" /></span>
    </button>
  </div>
  <div class="modal-body modal-background">
    <div class="popup-form">
      <form [formGroup]="multipleEmailForm">
        <div>
          <div class="box-wrap not-selectable">
            <div class="row">
              <div class="col-sm-12 col-12 input-login">
                <input _ngcontent-iam-c175="" autocomplete="off" type="text" required="" formControlName="email"
                  id="txtEmail" autocomplete="off" #email maxlength="32"
                  [ngClass]="{ 'is-invalid': multiEmailFormSubmit && (multiEmailControlGetter['email'].errors || showEmailMessage)}"
                  class="border-input ng-pristine ng-touched position-relative modal-color val-css"
                  data-testid="addnew-claims-multiple-email-input" (keypress)="whiteSpace($event)"
                  (keyup)="checkDuplicateEmail($event, email.value)" (keydown.enter)="addEmailOnEnter()">
                <span class="plus-icon-claim icon-cursor" (click)="addMultipleEmail(true, false)">
                  <svg width="15" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 12.4667H12.4667V22H9.53333V12.4667H0V9.53333H9.53333V0H12.4667V9.53333H22V12.4667Z"
                      fill="#6452C5" />
                  </svg>
                </span>
                <label _ngcontent-iam-c175="">Email</label>

                <div class="alignment-list" *ngFor="let emailAddress of multipleEmailData; index as i">
                  <div class="chip">
                    <div class="chip-content modal-color">{{emailAddress}}</div>
                    <div class="chip-close icon-cursor" (click)="removeMultipleEmail(i)"
                      data-testid="addnew-claims-multiple-email-remove-multiple-button">
                      <svg width="15" height="20" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1"
                        viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path
                          d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"
                          fill="#d94d51" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-box pdgtb">
          <button type="submit" class="btn-wrap red-btn CancelBox modal-color"
            (click)="modal.dismiss('Cross click'); closeMultipleEmailModel()"
            data-testid="addnew-claims-multiple-email-cancel-button">
            Cancel
          </button>&nbsp;
          <button type="submit" class="btn-wrap CancelBox modal-color" (click)="saveEmailAddress()"
            data-testid="addnew-claims-multiple-email-save-button">
            Save
          </button>&nbsp;
        </div>
      </form>
    </div>

  </div>
</ng-template>

<!-- Modal - Multiple Additional Address -->
<ng-template #multipleAddress let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Additional address</h5>
    <button type="button" class="close close-icon" aria-label="Close"
      data-testid="addnew-claims-multiple-address-close-button"
      (click)="closeMultipleAddressModel(); modal.dismiss('Cross click')"
      style="z-index: 1050; position: relative;">
      <span aria-hidden="true"><img src="../../../../../assets/images/close.svg" /></span>
    </button>
  </div>
  <div class="modal-body modal-background">
    <div class="popup-form">
      <form [formGroup]="multipleAddressForm" (ngSubmit)="$event.preventDefault()">
        <div>
          <div class="box-wrap not-selectable">
            <div class="row">
              <div class="col-sm-12 col-12 input-login position-relative additional-address-input">
                <input _ngcontent-iam-c175="" autocomplete="off" type="text" formControlName="address"
                  id="txtAdditionalAddress" autocomplete="off" #address maxlength="150"
                  [ngClass]="{ 'is-invalid': additionalAddressEmptyAddAttempt || ((multipleAddressForm.get('address')?.value?.trim()) && ((isValidAdditionalZip || additionalAddressInvalid) || (multiAddressFormSubmit && (multiAddressControlGetter['address'].errors || showAddressMessage))))}"
                  class="border-input ng-pristine ng-touched modal-color val-css position-relative focus additionalAddressFocus"
                  [class.has-value]="multipleAddressForm?.get('address')?.value"
                  data-testid="addnew-claims-multiple-address-input"
                  (keyup)="updateAdditionalAddressLabelPosition(address.value); onAdditionalAddressZipCheck()"
                  (keydown)="onAdditionalAddressInputKeydown($event)"
                  (focus)="onAdditionalAddressFocus()"
                  (blur)="updateAdditionalAddressLabelPosition(address.value); onAdditionalAddressBlur(); onAddressOrAdditionalAddressBlur()">
                <span class="plus-icon-claim icon-cursor" (mousedown)="onAdditionalAddressPlusMousedown()" (click)="addMultipleAddress(true, false)">
                  <svg width="15" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 12.4667H12.4667V22H9.53333V12.4667H0V9.53333H9.53333V0H12.4667V9.53333H22V12.4667Z"
                      fill="#6452C5" />
                  </svg>
                </span>
                <label _ngcontent-iam-c175="">Additional address</label>
                <div class="max-phone-invalid" *ngIf="showAddressMessage">{{ showAddressMessage }}</div>
                
                <ul *ngIf="additionalAddressSuggestions.length && showAdditionalAddressSuggestions" 
                    class="list-group suggestion-box additional-address-suggestions">
                  <li *ngFor="let suggestion of additionalAddressSuggestions; let i = index" 
                      class="list-group-item list-group-item-action"
                      [class.active]="i === highlightedAdditionalAddressSuggestionIndex"
                      (mousedown)="$event.preventDefault(); selectAdditionalAddressSuggestion(suggestion)"
                      (click)="selectAdditionalAddressSuggestion(suggestion)"
                      [attr.tabindex]="0">
                    {{ suggestion }}
                  </li>
                </ul>

                <div class="alignment-list" *ngFor="let addressItem of multipleAddressData; index as i">
                  <div class="chip">
                    <div class="chip-content modal-color">{{addressItem}}</div>
                    <div class="chip-close icon-cursor" (click)="removeMultipleAddress(i)"
                      data-testid="addnew-claims-multiple-address-remove-multiple-button">
                      <svg width="15" height="20" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1"
                        viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path
                          d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"
                          fill="#d94d51" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-box pdgtb">
          <button type="submit" class="btn-wrap red-btn CancelBox modal-color"
            (click)="modal.dismiss('Cross click'); closeMultipleAddressModel()"
            data-testid="addnew-claims-multiple-address-cancel-button">
            Cancel
          </button>&nbsp;
          <button type="submit" class="btn-wrap CancelBox modal-color" (click)="saveAddress()"
            data-testid="addnew-claims-multiple-address-save-button">
            Save
          </button>&nbsp;
        </div>
      </form>
    </div>

  </div>
</ng-template>

<!-- Modal - Multiple Key Words -->
<ng-template #multipleKeyword let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Keywords</h5>
    <button type="button" class="close close-icon" aria-label="Close"
      data-testid="addnew-claims- multiple-keyword-close-button"
      (click)="modal.dismiss('Cross click'); closeMultipleKeywordModal()">
      <span aria-hidden="true"><img src="../../../../../assets/images/close.svg" /></span>
    </button>
  </div>
  <div class="modal-body modal-background">
    <div class="popup-form">
      <form [formGroup]="multipleKeywordForm">
        <div>
          <div class="box-wrap not-selectable">
            <div class="row">
              <div class="col-sm-12 col-12 input-login">
                <input type="text" autocomplete="off" required
                  class="border-input position-relative modal-color val-css" #keyword
                  data-testid="addnew-claims-multiple-keyword-input" formControlName="keyword" maxlength="30"
                  [ngClass]="{ 'is-invalid': multiKeywordFormSubmit && (multiKeywordControlGetter['keyword'].errors || showKeywordMessage)}"
                  (keyup)="checkDuplicateKeyword($event, keyword.value)" (keydown.enter)="addKeywordOnEnter()">
                <span class="plus-icon-claim icon-cursor" (click)="addMultipleKeyword(true, false)"
                  data-testid="addnew-claims-multiple-keyword-add-button">
                  <svg width="15" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 12.4667H12.4667V22H9.53333V12.4667H0V9.53333H9.53333V0H12.4667V9.53333H22V12.4667Z"
                      fill="#6452C5" />
                  </svg>
                </span>
                <label class="label">Keywords</label>

                <div class="alignment-list" *ngFor="let keywords of multipleKeywordData; index as i">
                  <div class="chip">
                    <div class="chip-content modal-color">{{keywords}}</div>
                    <div class="chip-close icon-cursor" (click)="removeKeyword(i)"
                      [attr.data-testid]="'addnew-claims-multiple-keyword-remove-button'">
                      <svg width="15" height="20" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1"
                        viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path
                          d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"
                          fill="#d94d51" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-box pdgtb">
          <button type="submit" class="btn-wrap red-btn CancelBox modal-color"
            (click)="modal.dismiss('Cross click'); closeMultipleKeywordModal()"
            data-testid="addnew-claims-multiple-keyword-cancel-button">
            Cancel
          </button>&nbsp;
          <button type="submit" class="btn-wrap CancelBox modal-color" (click)="saveKeyword()"
            data-testid="addnew-claims-multiple-keyword-save-button">
            Save
          </button>&nbsp;
        </div>
      </form>
    </div>
  </div>
</ng-template>

<!-- Modal - Multiple Link Analysis -->
<ng-template #multipleLinkAnalysis let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Link analysis</h5>
    <button type="button" class="close close-icon" aria-label="Close"
      data-testid="addnew-claims-multiple-linkAnalysis-close-button"
      (click)="modal.dismiss('Cross click'); closeMultipleLinkAnalysisModal()">
      <span aria-hidden="true"><img src="../../../../../assets/images/close.svg" /></span>
    </button>
  </div>
  <div class="modal-body modal-background">
    <div class="popup-form">
      <form [formGroup]="multipleLinkAnalysisForm">
        <div>
          <div class="box-wrap not-selectable">
            <div class="row">
              <div class="col-sm-12 col-12 input-login">
                <input type="text" autocomplete="off" required
                  class="border-input position-relative modal-color val-css" #linkAnalysis
                  data-testid="addnew-claims-multiple-linkAnalysis-input" formControlName="linkAnalysis" maxlength="30"
                  (keyup)="checkDuplicateLinkAnalysis($event, linkAnalysis.value)"
                  (keydown.enter)="addLinkAnalysisOnEnter()"
                  [ngClass]="{ 'is-invalid': multiLinkAnalysisFormSubmit && (!isAllowedMultipleLinkAnalysis || multiLinkAnalysisControlGetter['linkAnalysis'].errors || showLinkAnalysisMessage || this.multipleLinkAnalysisForm.get('linkAnalysis')?.hasError('invalid'))}" />
                <!-- [ngClass]="{ 'is-invalid': multiLinkAnalysisFormSubmit && (multiLinkAnalysisControlGetter['linkAnalysis'].errors || showLinkAnalysisMessage)}" /> -->
                <span class="plus-icon-claim icon-cursor" (click)="addMultipleLinkAnalysis(true, false)"
                  data-testid="addnew-claims-multiple-linkAnalysis-add-button">
                  <svg width="15" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 12.4667H12.4667V22H9.53333V12.4667H0V9.53333H9.53333V0H12.4667V9.53333H22V12.4667Z"
                      fill="#6452C5" />
                  </svg>
                </span>
                <label class="label">Name</label>
                <div class="max-phone-invalid" *ngIf="!isAllowedMultipleLinkAnalysis">Max three link analysis allowed to add</div>
                <div class="alignment-list" *ngFor="let linkAnalysis of multipleLinkAnalysisData; index as i">
                  <div class="chip">
                    <div class="chip-content modal-color">{{linkAnalysis}}</div>
                    <div class="chip-close icon-cursor" (click)="removeLinkAnalysis(i)"
                      [attr.data-testid]="'addnew-claims-multiple-linkAnalysis-remove-button'">
                      <svg width="15" height="20" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1"
                        viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path
                          d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"
                          fill="#d94d51" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-box pdgtb">
          <button type="submit" class="btn-wrap red-btn CancelBox modal-color"
            (click)="modal.dismiss('Cross click'); closeMultipleLinkAnalysisModal()"
            data-testid="addnew-claims-multiple-linkAnalysis-cancel-button">
            Cancel
          </button>&nbsp;
          <button type="submit" class="btn-wrap CancelBox modal-color" (click)="saveLinkAnalysis()"
            data-testid="addnew-claims-multiple-linkAnalysis-save-button">
            Save
          </button>&nbsp;
        </div>
      </form>
    </div>
  </div>
</ng-template>

<!-- Modal - Multiple Known As -->
<ng-template #multipleKnownAs let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Known as</h5>
    <button type="button" class="close close-icon" aria-label="Close"
      data-testid="addnew-claims-multiple-knownAs-close-button"
      (click)="modal.dismiss('Cross click'); closeMultipleKnownAsModal()">
      <span aria-hidden="true"><img src="../../../../../assets/images/close.svg" /></span>
    </button>
  </div>
  <div class="modal-body modal-background">
    <div class="popup-form">
      <form [formGroup]="multipleKnownAsForm">
        <div>
          <div class="box-wrap not-selectable">
            <div class="row">
              <div class="col-sm-12 col-12 input-login">
                <input type="text" autocomplete="off" required
                  class="border-input position-relative modal-color val-css" #knownAs
                  data-testid="addnew-claims-multiple-knownAs-input" formControlName="knownAs" maxlength="30"
                  (keyup)="checkDuplicateKnownAs($event, knownAs.value)" (keydown.enter)="addKnownAsOnEnter()"
                  [ngClass]="{ 'is-invalid': multipleKnownAsFormSubmit && (!isAllowedMultipleKnownAs || multiKnownAsControlGetter['knownAs'].errors || showKnownAsMessage || this.multipleKnownAsForm.get('knownAs')?.hasError('invalid'))}" />
                <!-- [ngClass]="{ 'is-invalid': multipleKnownAsFormSubmit && (multiKnownAsControlGetter['knownAs'].errors || showKnownAsMessage)}" /> -->
                <span class="plus-icon-claim icon-cursor" (click)="addMultipleKnownAs(true, false)"
                  data-testid="addnew-claims-multiple-knownAs-add-button">
                  <svg width="15" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 12.4667H12.4667V22H9.53333V12.4667H0V9.53333H9.53333V0H12.4667V9.53333H22V12.4667Z"
                      fill="#6452C5" />
                  </svg>
                </span>
                <label class="label">Name</label>
                <div class="max-phone-invalid" *ngIf="!isAllowedMultipleKnownAs">Max five known as allowed to add</div>
                <div class="alignment-list" *ngFor="let knownAs of multipleKnownAsData; index as i">
                  <div class="chip">
                    <div class="chip-content modal-color">{{knownAs}}</div>
                    <div class="chip-close icon-cursor" (click)="removeKnownAs(i)"
                      [attr.data-testid]="'addnew-claims-multiple-knownAs-remove-button'">
                      <svg width="15" height="20" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1"
                        viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path
                          d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"
                          fill="#d94d51" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-box pdgtb">
          <button type="submit" class="btn-wrap red-btn CancelBox modal-color"
            (click)="modal.dismiss('Cross click'); closeMultipleKnownAsModal()"
            data-testid="addnew-claims-multiple-knownAs-cancel-button">
            Cancel
          </button>&nbsp;
          <button type="submit" class="btn-wrap CancelBox modal-color" (click)="saveKnownAs()"
            data-testid="addnew-claims-multiple-knownAs-save-button">
            Save
          </button>&nbsp;
        </div>
      </form>
    </div>
  </div>
</ng-template>

<!-- Review popup start -->
<ng-template #content let-modal id="test-modal">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Review uploaded {{reviewFormName}} - {{validUploadedData}} of
      {{ totalUploadedData }} {{requestText}} missing data </h6>
    <button type="button" class="close" aria-label="Close" (click)="cancelSaveBatchRequestRecords()"
      data-testid="addnew-claims-review-batch-close-button">
      <span aria-hidden="true"><img src="../../../../../assets/images/close.svg" /></span>
    </button>
  </div>
  <div class="modal-body modal-color modal-body-census modal-body-height" style="padding: 0% !important;">
    <div class="tableFixHead" (scroll)="onScroll($event)">
      <!-- tableFixHead  -->
      <table class="table bortn census-table table-fixed review-uploaded-table">
        <thead>
          <tr id="table-spacing" style="font-size: 12px;line-height: 14px;">
            <th colspan="7">
            </th>
            <th colspan="4">
            </th>
            <th colspan="1">
            </th>
          </tr>
          <tr style="font-size: 12px;line-height: 14px;" class="optional">
            <th colspan="7">
            </th>
            <th class="position-relative" colspan="4">
              <div class="position-absolute top-label">
                <p class="bold-optional">Optional</p>
              </div>
            </th>
            <th colspan="1">
            </th>
          </tr>
          <tr style="font-size: 12px;line-height: 14px; width: 100%;">
            <th style="width: 11%; padding-left: 15px;">
              First name
              <button class="sort-by" data-testid="addnew-claims-first-name-button">
                <span>
                  <i class="fa fa-angle-up" id="stFirstNameAsc" (click)="sort('Firstname', 'asc'); "
                    [ngClass]="{ sortActiveclass: upFirstname }" aria-hidden="true"></i>
                  <i class="fa fa-angle-down" id="stFirstNameDesc" (click)="sort('Firstname', 'desc'); "
                    [ngClass]="{ sortActiveclass: downFirstname }" aria-hidden="true"></i>
                </span>
              </button>
            </th>
            <th style="width: 11%;">
              Last name
              <button class="sort-by" data-testid="addnew-claims-last-name-button">
                <span>
                  <i class="fa fa-angle-up" id="stLastNameAsc" (click)="sort('Lastname', 'asc'); "
                    [ngClass]="{ sortActiveclass: upLastname }" aria-hidden="true"></i>
                  <i class="fa fa-angle-down" id="stLastNameDesc" (click)="sort('Lastname', 'desc'); "
                    [ngClass]="{ sortActiveclass: downLastname }" aria-hidden="true"></i>
                </span>
              </button>
            </th>
            <th style="width: 7%;">
              Date of birth
              <button class="sort-by" data-testid="addnew-claims-date-of-birth-button">
                <span>
                  <i class="fa fa-angle-up" id="stDateofbirthAsc" (click)="sort('Dateofbirth', 'asc');  "
                    [ngClass]="{ sortActiveclass: upBirthyear }" aria-hidden="true"></i>
                  <i class="fa fa-angle-down" id="stDateofbirthDesc" (click)="sort('Dateofbirth', 'desc'); "
                    [ngClass]="{ sortActiveclass: downBirthyear }" aria-hidden="true"></i>
                </span>
              </button>
            </th>

             <th id="addressColumn" class="address-column">
              Address
              <button class="sort-by" data-testid="addnew-claims-address-button">
                <span>
                  <i class="fa fa-angle-up" id="stAddressAsc" (click)="sort('Address', 'asc'); "
                    [ngClass]="{ sortActiveclass: upAddress }" aria-hidden="true"></i>
                  <i class="fa fa-angle-down" id="stAddressDesc" (click)="sort('Address', 'desc'); "
                    [ngClass]="{ sortActiveclass: downAddress }" aria-hidden="true"></i>
                </span>
              </button>
            </th>
           
            <!-- <th style="width: 4%;">
              Zip code 
              <button class="sort-by" data-testid="addnew-claims-zip-button">
                <span>
                  <i class="fa fa-angle-up" id="stZipcodeAsc" (click)="sort('Zip', 'asc'); "
                    [ngClass]="{ sortActiveclass: upZipcode }" aria-hidden="true"></i>
                  <i class="fa fa-angle-down" id="stZipcodeDesc" (click)="sort('Zip', 'desc');"
                    [ngClass]="{ sortActiveclass: downZipcode }" aria-hidden="true"></i>
                </span>
              </button>
            </th> -->
            
            <th style="width: 13%; min-width: 100px;">
              Look-back date
              <i class="fa fa-info-circle injury-date-batch injury-info-batch" placement="top"
                [ngbPopover]="injuryDateContent" popoverClass="volumePopover widthPopover-batch mac-alignment" triggers="mouseenter:mouseleave">
              </i>
              <button class="sort-by" data-testid="addnew-claims-claim-date-button">
                <span>
                  <i class="fa fa-angle-up" id="dtClaimFileAsc" (click)="sort('ClaimFile', 'asc');"
                    [ngClass]="{ sortActiveclass: upClaimFile }" aria-hidden="true"></i>
                  <i class="fa fa-angle-down" id="dtClaimFileDesc" (click)="sort('ClaimFile', 'desc');"
                    [ngClass]="{ sortActiveclass: downClaimFile }" aria-hidden="true"></i>
                </span>
              </button>
              <ng-template #injuryDateContent>
                <div>
                  Extra charge applies beyond 24 months
                 </div>
            </ng-template>
            </th>
            
            <th style="width: 10%;">
              Reference #
              <button class="sort-by" data-testid="addnew-claims-reference-id-button">
                <span>
                  <i class="fa fa-angle-up" id="stReferenceIdAsc" (click)="sort('ReferenceId', 'asc'); "
                    [ngClass]="{ sortActiveclass: upReferenceID }" aria-hidden="true"></i>
                  <i class="fa fa-angle-down" id="stReferenceIdDesc" (click)="sort('ReferenceId', 'desc'); "
                    [ngClass]="{ sortActiveclass: downReferenceID }" aria-hidden="true"></i>
                </span>
              </button>
            </th>
            <th style="width: 13%;">
              Report type
              <button class="sort-by" data-testid="addnew-claims-report-type-button">
                <span>
                  <i class="fa fa-angle-up" id="stReporttypeAsc" (click)="sort('Reporttype', 'asc'); "
                    [ngClass]="{ sortActiveclass: upReporttype }" aria-hidden="true"></i>
                  <i class="fa fa-angle-down" id="stReporttypeDesc" (click)="sort('Reporttype', 'desc'); "
                    [ngClass]="{ sortActiveclass: downReporttype }" aria-hidden="true"></i>
                </span>
              </button>
            </th>
            <th style="width: 7%;" class="border-left">
              Gender
              <button class="sort-by" data-testid="addnew-claims-gender-button">
                <span>
                  <i class="fa fa-angle-up" id="stGenderAsc" (click)="sort('Gender', 'asc'); "
                    [ngClass]="{ sortActiveclass: upGender }" aria-hidden="true"></i>
                  <i class="fa fa-angle-down" id="stGenderDesc" (click)="sort('Gender', 'desc'); "
                    [ngClass]="{ sortActiveclass: downGender }" aria-hidden="true"></i>
                </span>
              </button>
            </th>
            <th style="width: 8%;">
              Limitation
              <button class="sort-by" data-testid="addnew-claims-limitation-button">
                <span>
                  <i class="fa fa-angle-up" id="stPhylimitationAsc" (click)="sort('Limitation', 'asc'); "
                    [ngClass]="{ sortActiveclass: upPhyLimitation }" aria-hidden="true"></i>
                  <i class="fa fa-angle-down" id="stPhylimitationDesc" (click)="sort('Limitation', 'desc'); "
                    [ngClass]="{ sortActiveclass: downPhyLimitation }" aria-hidden="true"></i>
                </span>
              </button>
            </th>
            <th style="width: 8%;">
              Phone number
              <button class="sort-by" data-testid="addnew-claims-phone-button">
                <span>
                  <i class="fa fa-angle-up" id="stPhoneAsc" (click)="sort('Phone', 'asc');"
                    [ngClass]="{ sortActiveclass: upPhone }" aria-hidden="true"></i>
                  <i class="fa fa-angle-down" id="stPhoneDesc" (click)="sort('Phone', 'desc');"
                    [ngClass]="{ sortActiveclass: downPhone }" aria-hidden="true"></i>
                </span>
              </button>
            </th>
            <th class="border-right email-column">
              Email
              <button class="sort-by" data-testid="addnew-claims-email-button">
                <span>
                  <i class="fa fa-angle-up" id="stEmailAsc" (click)="sort('Email', 'asc'); "
                    [ngClass]="{ sortActiveclass: upEmail }" aria-hidden="true"></i>
                  <i class="fa fa-angle-down" id="stEmailDesc" (click)="sort('Email', 'desc');  "
                    [ngClass]="{ sortActiveclass: downEmail }" aria-hidden="true"></i>
                </span>
              </button>
            </th>
            <th class="check-header">
              Check
              <button class="sort-by" data-testid="addnew-claims-check-button">
                <span style="margin-left: 2px;">
                  <i class="fa fa-angle-up" id="inStatusAsc" (click)="sort('inStatus', 'asc'); "
                    [ngClass]="{ sortActiveclass: upCheck }" aria-hidden="true"></i>
                  <i class="fa fa-angle-down" id="inStatusDesc" (click)="sort('inStatus', 'desc');  "
                    [ngClass]="{ sortActiveclass: downCheck }" aria-hidden="true"></i>
                </span>
              </button>
            </th>
          </tr>
        </thead>
        <tbody class="">
          <ng-container *ngFor="let objBatch of getBatchDataResponse;  let id = index">
            <tr style="font-size: 12px;">
              <td style="padding-left: 5px;">
                  <input type="text"
                    (keyup)="changeClaimRequestValues(id, 'Firstname', $event,'firstnamekeyuup')"
                    (keypress)="checkLength(id, 'Firstname', $event, 100);" class="name-width"
                    data-testid="addnew-claims-batch-firstname-input" (blur)="updateList(id, 'Firstname', $event)"
                    id="{{id}}Firstname" autocomplete="off"
                    [ngClass]="setDynamicClassesForFullName(objBatch.Firstname, id)"
                    [(ngModel)]="objBatch.Firstname" contenteditable="true" />
                <span class="review-error d-none" [hidden]="true" id="{{id}}firstNameValid"></span>
              </td>
              <td>
                  <input type="text"
                    (keyup)="changeClaimRequestValues(id, 'Lastname', $event,'lastnamekeyup')"
                    (keypress)="checkLength(id, 'Lastname', $event, 50);" class="name-width"
                    data-testid="addnew-claims-batch-lastname-input" (blur)="updateList(id, 'Lastname', $event)"
                    id="{{id}}Lastname" autocomplete="off"
                    [ngClass]="setDynamicClassesForFullName(objBatch.Lastname, id)"
                    [(ngModel)]="objBatch.Lastname" contenteditable="true" />
                <span class="review-error d-none" [hidden]="true" id="{{id}}lastNameValid"></span>
              </td>
              <td class="batch-date-width">
                <input type="text" class="name-width input-placeholder-lowercase"
                  #datepickerDB="bsDatepicker"
                  (input)="onInputChange($event, id, datepickerDB)"
                  [bsConfig]="{ isAnimated: true }" [bsConfig]="isMobile ? datePickerConfig : batchDatePickerConfig"
                  bsDatepicker [maxDate]="today" [placement]="isMobile ? 'bottom' : 'right'"
                  (ngModelChange)="onDateChange($event,id,'DateofBirth')" id="{{id}}DateofBirth"
                  [ngClass]="{'search span-text InputBlank blank-date-width': objBatch.DateofBirth === '' || objBatch.DateofBirth === undefined,
                    'search-no-border span-text InputData': !(objBatch.DateofBirth === '' || objBatch.DateofBirth === undefined),
                    'invalid-age': objBatch.invalidAge
                  }"
                  (keyup)="changeClaimRequestValues(id, 'DateofBirth', $event,'dobkeyup')"
                  (blur)="onDateFieldblur(id, 'DateofBirth',  $event, datepickerDB); updateList(id, 'DateofBirth', $event);"
                  [(ngModel)]="objBatch.DateofBirth" contenteditable="true" autocomplete="off" placeholder="mm/dd/yyyy"
                  (keypress)="dateAllowNumericSlash($event); whiteSpace($event);"
                  (onHidden)="onDatepickerClosed(id, 'DateofBirth', objBatch.DateofBirth)"
                  
                  data-testid="addnew-claims-batch-date-of-birth-input"
                  onKeyPress="if(this.value.length==10) return false;" (copy)="$event.preventDefault()"
                  (paste)="$event.preventDefault()" />
                <span class="review-error date-error d-none" [hidden]="true" id="{{id}}DateofBirthInvalid"></span>
              </td>
              <!-- <td>
                <input type="text"
                  (keyup)="batchAddressValidation(id, 'Address', 'addressValid'); changeClaimRequestValues(id, 'Address', $event,'addressKeyup')"
                  (keypress)="checkLength(id, 'Address', $event, 100);" class="name-width"
                  data-testid="addnew-claims-batch-address-input" (blur)="updateList(id, 'Address', $event)"
                  id="{{id}}Address" autocomplete="off"
                  [ngClass]="setDynamicClassesForAddress(objBatch.Address, id)"
                  (blur)="changeClaimRequestValues(id, 'Address', $event,'blur'); updateList(id, 'Address', $event);"
                  [(ngModel)]="objBatch.Address" contenteditable="true" (focus)="addressOnFocus()" />
                      

              <ul *ngIf="addressSuggestionsMap[id]?.length && showSuggestionsMap[id]" 
                  class="list-group suggestion-box">
                <li *ngFor="let suggestion of addressSuggestionsMap[id]" 
                    class="list-group-item list-group-item-action"
                    (click)="selectBatchSuggestion(id, suggestion)">
                  {{ suggestion }}
                </li>
              </ul>
                <span class="review-error d-none" [hidden]="true" id="{{id}}addressValid"></span>
              </td> -->
              <td>
            <div class="address-input position-relative">
                <input type="text"
                  (keyup)="changeClaimRequestValues(id, 'Address', $event,'addressKeyup')"
                  (blur)="changeClaimRequestValues(id, 'Address', $event,'blur'); updateList(id, 'Address', $event); onAddressOrAdditionalAddressBlur()"
                  (focus)="onAddressInputFocus(id, $event)"
                  (keypress)="checkLength(id, 'Address', $event, 100);" 
                  class="name-width"
                  data-testid="addnew-claims-batch-reference-id-input" 
                  id="{{id}}Address" 
                  (keydown)="onBatchAddressInputKeydown($event, id)"
                  autocomplete="off"
                  [ngClass]="objBatch.Address == '' ? 'search span-text InputBlank blank-input-width' : 'search-no-border span-text InputData input-width'"
                  [(ngModel)]="objBatch.Address" contenteditable="true" />
            </div>

            <span class="review-error d-none" [hidden]="true" id="{{id}}addressValid"></span>
          </td>

              <!-- <td>
                <input type="Text" class="name-width" maxlength="7" contenteditable="true"
                  (change)="batchzipValidation(id, $event); changeClaimRequestValues(id, 'Zipcode', $event,'zipkeyup');"
                  (copy)="$event.preventDefault()" placeholder="00000"
                  (keyup)="batchzipValidation(id, $event); changeClaimRequestValues(id, 'Zip', $event,'zipkeyup');"
                  (blur)="updateList(id, 'Zip', $event);" id="{{id}}Zipcode" data-testid="addnew-claims-batch-zip-input"
                  [ngClass]="objBatch.Zip == '' ? 'search span-text InputBlank blank-zipcode-input-width' : 'search-no-border span-text InputData input-width'"
                  [(ngModel)]="objBatch.Zip" />
                <span class="review-error d-none" [hidden]="true" id="{{id}}ZipCodevalid"></span>
              </td> -->
            
              <td class="batch-date-width input-login">
                <input type="text" class="name-width input-placeholder-lowercase look-backdate-align"
                  (keyup)="changeClaimRequestValues(id, 'dtClaimFile', $event,'claimkeyup')"
                  #datepickerLD="bsDatepicker"
                  [bsConfig]="{ isAnimated: true }" [bsConfig]="isMobile ? datePickerConfig : batchDatePickerConfig"
                  bsDatepicker [maxDate]="today" [placement]="isMobile ? 'bottom' : 'right'"
                  (ngModelChange)="onDateChange($event,id,'dtClaimFile')" id="{{id}}dtClaimFile"
                  [ngClass]="objBatch.dtClaimFile == '' || objBatch.dtClaimFile == undefined ? 'search span-text InputBlank blank-date-width' : 'search-no-border span-text dollor-before InputData'"
                  [(ngModel)]="objBatch.dtClaimFile" contenteditable="true" autocomplete="off" placeholder="mm/dd/yyyy"
                  (keypress)="dateAllowNumericSlash($event); whiteSpace($event);"
                  data-testid="addnew-claims-batch-claim-file-input"
                  onKeyPress="if(this.value.length==10) return false;" (copy)="$event.preventDefault()"
                  (blur)="onDateFieldblur(id, 'dtClaimFile', $event, datepickerLD); updateList(id, 'dtClaimFile', $event);"
                  (input)="onInputChange($event, id, datepickerLD)"
                  (paste)="$event.preventDefault()" />
                  <fa-icon popoverClass="volumePopover" triggers="mouseenter:mouseleave" [ngbPopover]="lookbackdatebatch" *ngIf="!checkDateWithinTwentyFourMonths(objBatch.dtClaimFile)" class="warning-icon-batch" [icon]="faWarning"></fa-icon>
                <span class="review-error date-error d-none" [hidden]="true" id="{{id}}ClaimfileDateInvalid"></span>
                <ng-template #lookbackdatebatch>
                  <div>
                    Extra charge applies beyond 24 months
                  </div>
              </ng-template>
              </td>

              <td>
                <input type="text"
                  (keyup)="changeClaimRequestValues(id, 'ReferenceId', $event,'claimkeyup')"
                  (blur)="changeClaimRequestValues(id, 'ReferenceId', $event,'blur')"
                  (keypress)="checkLength(id, 'ReferenceId', $event, 30);" class="name-width"
                  data-testid="addnew-claims-batch-reference-id-input" 
                  (blur)="updateList(id, 'ReferenceId', $event);"
                  id="{{id}}ReferenceId" autocomplete="off"
                  [ngClass]="objBatch.ReferenceId == '' ? 'search span-text InputBlank blank-input-width' : 'search-no-border span-text InputData input-width'"
                  [(ngModel)]="objBatch.ReferenceId" contenteditable="true" />
                <span class="review-error d-none" [hidden]="true" id="{{id}}referenceIdValid"></span>
              </td>
              <td>
                <select class="border-input sel-mat-inp batch-dropdown-bg select batch-dropdown" #prPage
                  data-testid="addnew-claims-batch-page-select"
                  (change)="onchangeReportTypeReviewPopup(id,prPage.value,objBatch.Reporttype);"
                  id="{{id}}ddlReportType">
                  <option value="" class="mrgl45">Select</option>
                  <ng-container *ngFor="let objReportType of arrReportType | keyvalue">
                    <option *ngIf="objBatch.Reporttype != objReportType.key" [value]="objReportType.value"
                    [attr.disabled]=" (objReportType.value === 1 && objBatch.LinkAnalysis?.length > 0 && !isBasicReport) ||
                    (objReportType.value === 1 && !isBasicReport) ||
                    (objReportType.value === 2 && !isEnhancedReport) ||
                    (objReportType.value === 3 && !isMonitoringReport) ||
                    (objReportType.value === 4 && !isIdentityReport) ? true : null">
                      <span>{{objReportType.key}}</span>
                    </option>
                    <option *ngIf="objBatch.Reporttype == objReportType.key" [value]="objReportType.value"
                      class="mrgl45" [attr.selected]="true">{{objBatch.Reporttype}}</option>
                  </ng-container>
                </select>
              </td>
              
              <td class="border-left">
                <select class="border-input sel-mat-inp batch-dropdown-bg select batch-dropdown" #gender
                  (change)="onchangeGender(id, gender.value)" data-testid="addnew-claims-batch-gender-select" id="{{id}}genderType">
                  <option value="" class="mrgl45">Select</option>
                  <ng-container *ngFor="let options of genderOptions">
                    <option *ngIf="objBatch.Gender != options.value" [value]="options.value">
                      <span>{{options.label}}</span>
                    </option>
                    <option *ngIf="objBatch.Gender == options.value" [value]="options.value" class="mrgl45"
                      [attr.selected]="true">{{options.label}}</option>
                  </ng-container>
                </select>
              </td>
              <td>
                <select class="border-input sel-mat-inp batch-dropdown-bg select batch-dropdown" #phyLimit
                  (change)="onchangePhysicalLimitation(id, phyLimit.value);"
                  data-testid="addnew-claims-batch-physical-limit-select" id="{{id}}ddlPhyLimitation">
                  <option value="" class="mrgl45">Select</option>
                  <ng-container *ngFor="let objPhyLimitation of arrPhyLimitation | keyvalue">
                    <option *ngIf="objBatch.Limitation != objPhyLimitation.key" [value]="objPhyLimitation.value">
                      <span>{{objPhyLimitation.value}}</span>
                    </option>
                    <option *ngIf="objBatch.Limitation == objPhyLimitation.key" [value]="objPhyLimitation.value"
                      class="mrgl45" [attr.selected]="true">{{objPhyLimitation.value}}</option>
                  </ng-container>
                </select>
              </td>
              <td>
                <input type="text" maxlength="14" autocomplete="off" style="width:160px;" readonly
                  class="icon-cursor phoneFocus" placeholder="(000) 000-0000"
                  [ngClass]="[objBatch.Phone == '' ? 'search span-text phoneInputBlank blank-optional-input-width' : 'search-no-border span-text dollor-before phoneInputData']"
                  (click)="showMultiplePhoneModel(multiplePhone, 'batch', id)" id="{{id}}Phone"
                  [(ngModel)]="objBatch.Phone" data-testid="addnew-claims-batch-phone-select" />
              </td>
              <td class="small-email border-right input-width">
                <input type="text" class="name-width" id="{{id}}Email" autocomplete="off" readonly
                  class="icon-cursor emailFocus"
                  [ngClass]="[objBatch.Email == '' ? 'search span-text InputBlank blank-optional-input-width' : 'search-no-border span-text dollor-before InputData']"
                  (click)="showMultipleEmailModel(multipleEmail, 'batch', id)" [(ngModel)]="objBatch.Email"
                  data-testid="addnew-claims-mutiple-email-input" />
              </td>
              <td *ngIf="objBatch.inStatus" style="text-align: center;" class="batch-check">
                <div style="width:50px;"><img src="../../../../assets/images/True.png"
                    style="height: 20px;margin-left:25px;"></div>
              </td>
              <td *ngIf="!objBatch.inStatus" style="text-align: center;" class="batch-check">
                <div style="width:50px;"><img src="../../../../assets/images/wrong.png"
                    style="height: 20px;margin-left:25px;"></div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn-wrap red-btn CancelBox" (click)="cancelSaveBatchRequestRecords()"
      data-testid="addnew-claims-batch-cancel-button">
      Cancel
    </button>
    <button type="button" class="btn-wrap btn-box" (click)="saveBatchRequestRecords(true)"
      data-testid="addnew-claims-batch-save-button">
      Save
    </button>
    <button type="button" class="btn-wrap btn-box" (click)="savesubmitBatchRequestRecords($event)"
      data-testid="addnew-claims-batch-save-submit-button">
      Save and Submit
    </button>
  </div>
  
  <!-- Floating Address Dropdown inside modal -->
  <div *ngIf="activeDropdownId !== null 
        && addressSuggestionsMap[activeDropdownId]?.length 
        && showSuggestionsMap[activeDropdownId]"
      class="addr-dd-root"
      [attr.data-batch-id]="activeDropdownId">

      <ul class="addr-dd-list list-group suggestion-box bg-none"
      [attr.data-batch-id]="activeDropdownId">

      <li *ngFor="let suggestion of addressSuggestionsMap[activeDropdownId]; let i = index"
        class="addr-dd-item list-group-item list-group-item-action border-none"
        [class.active]="i === highlightedBatchAddressSuggestionIndex[activeDropdownId]"
        (mousedown)="selectBatchSuggestion(activeDropdownId, suggestion)">
      {{ suggestion }}
      </li>
    </ul>
</div>
</ng-template>
<!-- Review popup End -->